var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { select, Store } from '@ngrx/store';
import { GET_INTEGRATION_IMPORT_ERRORS, GET_INTEGRATION_IMPORTS, GetIntegrationImportErrorsFailureAction, GetIntegrationImportErrorsSuccessAction, GetIntegrationImportsFailureAction, GetIntegrationImportsSuccessAction, SetIntegrationImportErrorsParamsAction, SetIntegrationImportsParamsAction } from './integration-imports.actions';
import { getIntegrationImportErrorsParamsSelector, getIntegrationImportsParamsSelector } from './integration-imports.reducer';
import { IntegrationsImportService } from './integration.import.service';
var IntegrationImportsEffects = /** @class */ (function () {
    function IntegrationImportsEffects(actions$, integrationsImportService, store) {
        var _this = this;
        this.actions$ = actions$;
        this.integrationsImportService = integrationsImportService;
        this.store = store;
        this.getIntegrationImports$ = this.actions$.pipe(ofType(GET_INTEGRATION_IMPORTS), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getIntegrationImportsParamsSelector))), switchMap(function (_a) {
            var payload = _a[0], params = _a[1];
            var completeParams = __assign({}, params, payload);
            return _this.integrationsImportService.fetch(completeParams).pipe(switchMap(function (response) {
                return [
                    new GetIntegrationImportsSuccessAction(response),
                    new SetIntegrationImportsParamsAction(completeParams)
                ];
            }), catchError(function (error) { return of(new GetIntegrationImportsFailureAction(error)); }));
        }));
        this.getIntegrationImportErrors$ = this.actions$.pipe(ofType(GET_INTEGRATION_IMPORT_ERRORS), map(function (action) { return action.payload; }), withLatestFrom(this.store.pipe(select(getIntegrationImportErrorsParamsSelector))), switchMap(function (_a) {
            var payload = _a[0], params = _a[1];
            var completeParams = __assign({}, params, payload);
            return _this.integrationsImportService.fetchErrors(completeParams).pipe(switchMap(function (response) {
                return [
                    new GetIntegrationImportErrorsSuccessAction(response),
                    new SetIntegrationImportErrorsParamsAction(completeParams)
                ];
            }), catchError(function (error) { return of(new GetIntegrationImportErrorsFailureAction(error)); }));
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], IntegrationImportsEffects.prototype, "getIntegrationImports$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], IntegrationImportsEffects.prototype, "getIntegrationImportErrors$", void 0);
    return IntegrationImportsEffects;
}());
export { IntegrationImportsEffects };
